module.exports = __webpack_public_path__ + "img/sld_ch_8_t1_green.535e9bd2.svg";